import { grayColor,container, title,
  // whiteColor 
} from "assets/jss/material-kit-pro-react";
import customSelectStyle from "assets/jss/material-kit-pro-react/gCustomSelectStyle.js";

const landingPageStyle = {
  ...customSelectStyle,
  container: {
    zIndex: "12",
    color: "#FFFFFF",
    ...container
  },
  title: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "30px",
    minHeight: "32px",
    color: "#FFFFFF",
    textDecoration: "none"
  },
  subtitle: {
    fontSize: "1.313rem",
    maxWidth: "500px",
    margin: "10px auto 0"
  },
  main: {
    background: grayColor[11],
    position: "relative",
    zIndex: "3"
  },
  mainRaised: {
    minHeight:"800px",
    margin: "-70px 10px 0px",
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
  },
  section: {
    //padding: "70px 0",
    textAlign: "center"
  },
  description: {
    color: "#999"
  },
  
  grid : {
    marginTop : "20px",
	},
	titleContainer: {
		margin: "20px 0 30px 0"
	},
	backButton :{
		float: 'left',
		overflow: 'hidden',
    margin:"10px auto auto 10px"
	},
	pageTitle:{
		padding: '20px 0 10px 0',
		color: grayColor[8],
		textAlign: 'center',
		overflow: 'hidden',
		fontSize: '26px',
		fontWeight: 'bold'
	},
	whatsapp :{
		borderRadius : "5px"
	}
};


export default landingPageStyle;
